export default __webpack_public_path__ + "static/media/735.61cdf7d9.gif";